angular.module('ApptBookApp').filter('gender', function() {
    return function(input) {
        if (input === 92)
        {
            return 'Female';
        }
        else if (input === 93)
        {
            return 'Male';
        }
        else
        {
            return 'Unknown';
        }
    };
});